import { pdfjs } from 'react-pdf';

// Log whether we've already initialized to prevent double initialization
let isInitialized = false;

/**
 * Singleton to manage PDF worker initialization
 */
class PDFWorkerManager {
  constructor() {
    if (isInitialized) {
      console.log('PDF Worker already initialized, skipping');
      return;
    }
    
    this.initialize();
    isInitialized = true;
  }
  
  initialize() {
    
    // Use the local copy of the worker - without the public prefix
    const localWorkerPath = `${window.location.origin}/pdf.worker.min.js`;
    
    // CDN fallback
    const cdnWorkerPath = 'https://unpkg.com/pdfjs-dist@4.8.69/build/pdf.worker.min.mjs';
    
    // Try to load the local worker first, if it fails, use the CDN
    this.checkWorkerAvailability(localWorkerPath)
      .then(workerSrc => {
        pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;
        
        // Configure for better performance
        pdfjs.GlobalWorkerOptions.workerPort = null;
      })
      .catch(error => {
        console.error('Error initializing PDF worker:', error);
      });
  }
  
  checkWorkerAvailability(localPath) {
    return fetch(localPath, { method: 'HEAD' })
      .then(() => localPath)
      .catch(error => {
        console.warn('Local PDF worker not available, using CDN fallback:', error);
        return this.cdnWorkerPath;
      });
  }
  
  // Singleton instance getter
  static getInstance() {
    if (!PDFWorkerManager.instance) {
      PDFWorkerManager.instance = new PDFWorkerManager();
    }
    return PDFWorkerManager.instance;
  }
}

// Initialize the singleton immediately 
const instance = PDFWorkerManager.getInstance();

export default instance;
